<template>
	<div class="support">
		<div class="content">
			<el-row :gutter="10">
				<el-col :span="6">
					<nav-menu :bgNav="imgNavPic" :menu="aNavMenu"></nav-menu>
				</el-col>
				<el-col :span="18">
					<div id="text" class="text">
						<div class="card">
							<img :src="imgHead"/>
						</div>
						<div class="article">
							<template v-if="isList">
								<div class="lists">
									<lists-menu :menu="aArticle"></lists-menu>
								</div>
							</template>
							<template v-else>
								<div class="tabs">
									<tabs-menu :menu="aArticle"></tabs-menu>
								</div>
							</template>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<foot></foot>	
	</div>
</template>

<script>
	import navMenu from '@/modules/nav-menu.vue'
	import foot from '@/modules/footer'	
	import tabsMenu from '@/modules/tabs-menu.vue'
	import listsMenu from '@/modules/lists-menu.vue'
	
	import supportArticle from '@/assets/data/support-article.js'
	
	export default {
		name: 'support',
		data() {
			var aArticle = null;
			var imgHead = null;
			if(this.$route.path.indexOf("_") < 0) {
				aArticle = supportArticle.aNavMenu[this.$route.path].content;
				imgHead = supportArticle.aNavMenu[this.$route.path].imgHead;
			
			} else {
				aArticle = supportArticle.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].content;
				imgHead = supportArticle.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].imgHead;
			
			}
			return {
				aArticle: aArticle,
				imgHead:imgHead,
			}
		},
		//计算数据
		computed: {
			aNavMenu: function() {
				return supportArticle.aNavMenu;
			},
			imgNavPic: function() {
				return supportArticle.imgNavPic;
			},
			isList:function(){
				var a = this.$route.path;
				
				if(a.indexOf("_")<0){
					return supportArticle.aNavMenu[this.$route.path].isList;
				}else{
					return supportArticle.aNavMenu[this.$route.path.split("_")[0]].child[this.$route.path].isList;
				}
			}
		},
		//参数数据
		props: {},
		//方法
		methods: {},
		//组件
		components: {			
			navMenu,		
			foot,
			tabsMenu,
			listsMenu
		},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {},
		//监控变量
		watch: {					
			"$route.path": function(newV) {
				if(newV.indexOf("_") < 0) {
					this.aArticle = supportArticle.aNavMenu[newV].content;
					this.imgHead = supportArticle.aNavMenu[newV].imgHead;
				} else {
					this.aArticle = supportArticle.aNavMenu[newV.split("_")[0]].child[newV].content;
					this.imgHead = supportArticle.aNavMenu[newV.split("_")[0]].child[newV].imgHead;
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import url("../assets/common.less");
	.support {
		.content{
			width: 1080px;
			margin: 100px auto;
			.text{
				min-height:100vh;
				.card{
					width: 100%;
					img {
						width: 100%;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Support.vue?227250c9